window.addEventListener('DOMContentLoaded', () => {
  const seoButton = document.querySelector('.js-seo-btn');
  const seoContent = document.querySelector('.js-seo-content');

  if (!seoButton || !seoContent) return;

  seoButton.addEventListener('click', () => {
    const isOpen = seoContent.classList.toggle('is-open');
    seoButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

    const label = seoButton.querySelector('.c-button__label');
    if (label) {
      label.textContent = seoContent.classList.contains('is-open')
        ? seoButton.dataset.openLabel
        : seoButton.dataset.closeLabel;
    }
  });
});
